(function () {

    "use strict";

    /**
     * Service para la gestión de documents 
     * @param {type} $http de Angular
     * @param {type} $q de Angular
     * @param {type} $timeout de Angular
     * @param {type} $rootScope de Angular
     * @param {type} Upload Service para la subida de ficheros
     * @param {type} URL Url constants
     */
    function documentsService($http, $q, $timeout, $rootScope, Upload, URL) {

        var self = this;
        var debug = true;

        self.gerUrlViewerEncode = function (data) {
            var url = URL.URL + '/api/documents/encode/url/viewer';
            return $q(function (resolve, reject) {
                $http({
                    method: 'POST',
                    url: url,
                    data: JSON.stringify(data),
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function () {
                        reject();
                    });
            });
        };

        self.gerUrlViewerEncodePublic = function (data) {
            var url = URL.URL + '/public/share/folder/encode/url/openviewer';
            return $q(function (resolve, reject) {
                $http({
                    method: 'POST',
                    url: url,
                    data: JSON.stringify(data),
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function () {
                        reject();
                    });
            });
        };

        self.sePuedeAbrirConOffice = function (idbox, iddocument, action) {
            var parametros = idbox + '/' + iddocument + '/' + action;
            var url = URL.URL + '/api/office/canview/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        console.log(response);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        self.abrirConOffice = function (idbox, iddocument, token, action, canprint) {
            var parametros = idbox + '/' + iddocument + '/' + token + '/' + action + '?canprint=' + canprint;
            var url = URL.URL + '/api/office/link/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        console.log(response);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        self.sePuedeAbrirConOffice_Drive = function (idProvider, idDrive, idFile, action) {
            var parametros = idProvider + "/" + idDrive + "/" + idFile + "/" + action;
            var url = URL.URL + "/api/office/canview_drive/" + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        console.log(response);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        // same as abrirConOffice but used for drive's documents
        self.abrirConOffice_Drive = function (idProvider, idDrive, idFile, token, action, canprint) {
            var parametros = idProvider + '/' + idDrive + '/' + idFile + '/' + token + '/' + action + '?canprint=' + canprint;
            var url = URL.URL + '/api/office/link/drive/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        console.log(response);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        self.getUrlAppViewer = function () {
            var url = URL.URL + '/api/appconfig/getconfiguration';
            return $q(function (resolve, reject) {
                $http.get(url, { cache: true }).then(function (response) {
                    console.log(response);
                    resolve(response.data);
                }).catch(function (error) {
                    console.log(error);
                    reject();
                });
            });
        };

        self.replaceFileItem = function (files, idFileItem) {

            var deferred = $q.defer();

            if (files && files.length) {

                angular.forEach(files, function (file) {
                    if (file && !file.$error) {

                        self.uploadingFiles.push(file);
                        $rootScope.$broadcast('solpheo_nueva_download', {});

                        Upload.upload({
                            url: '/api/fileitems/replace/workflow/' + idFileItem,
                            data: {
                                file: file
                            }
                        }).then(function (resp) {
                            $timeout(function () {
                                console.log('file: ' + resp.config.data.file.name + ', Response: ' + JSON.stringify(resp.data));
                                file.uploadOk = true;
                                deferred.notify('FILE_COMPLETE');
                            });
                        }, function (response) {
                            if (response.status > 0) {
                                console.log('Error: ' + response.status + ': ' + response.data);
                                file.errorMsg = "ERROR: " + response.status + ': ' + response.data;
                                file.inError = true;
                            }
                            deferred.notify('FILE_ERROR');
                        }, function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            if (debug) { console.log('Progress: ' + progressPercentage + '% ' + evt.config.data.file.name); }
                        });
                    }
                }, files);
            } else {
                deferred.reject('NO_FILE');
            }

            return deferred.promise;
        };

    }

    documentsService.$inject = ["$http", "$q", "$timeout", "$rootScope", "Upload", "URL"];

    angular.module("solpheo").service("solpheo.documentsService", documentsService);

})();